import { render } from "./MultiSelect.vue?vue&type=template&id=ceb80814&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=ceb80814&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-ceb80814"

export default script